export function getDistribution(answers, total) {
  let offset = 0;
  return answers.map(answer => {
    const share = total > 0 ? answer.count / total * 100 : 0;
    const item = { ...answer, share, offset, percentage: Math.round(share * 10) / 10 };
    offset += share;
    return item;
  });
}
export function formatSubmitted(value) {
  const parts = new Intl.DateTimeFormat("en-US", { timeZone: "Asia/Kolkata", year: "numeric", month: "2-digit", day: "2-digit", hour: "numeric", minute: "2-digit", second: "2-digit" }).formatToParts(new Date(value));
  const fields = Object.fromEntries(parts.map(part => [part.type, part.value]));
  return `${fields.day}/${fields.month}/${fields.year}, ${fields.hour}:${fields.minute}:${fields.second} ${fields.dayPeriod}`;
}

export function istDateBoundary(value, endOfDay = false) {
  // Explicit IST offset keeps date-only inputs independent of the browser timezone.
  return new Date(`${value}T${endOfDay ? "23:59:59.999" : "00:00:00.000"}+05:30`).toISOString();
}
